/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { toJS } from 'mobx';
import Framework from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';

const GraphHistoryVersionModel = types
  .model('GraphHistoryVersionModel', {
    graphData: types.maybeNull(types.frozen())
  })
  .views((self) => ({
    get graphHistoryVersionData() {
      return {
        graphData: self.graphData ? toJS(self.graphData) : null
      };
    }
  }))
  .actions((self) => ({
    // Fetch graph by object ID (historical version)
    getGraphHistoryVersion(payload) {
      Framework.getEventManager().publish(constants.GET_GRAPH_BY_OBJECT_ID, { payload });
    },

    // Set graph data response
    setGraphData(data) {
      applySnapshot(self, { ...getSnapshot(self), graphData: data || null });
      Framework.getEventManager().publish(constants.GET_GRAPH_BY_OBJECT_ID_SUCCESS, { data });
    },

    // Set error
    setError(errorMessage) {
      Framework.getEventManager().publish(constants.GET_GRAPH_BY_OBJECT_ID_ERROR, { error: errorMessage });
    },

    // Reset state
    resetState() {
      applySnapshot(self, {
        ...getSnapshot(self),
        graphData: null
      });
    }
  }));

export default GraphHistoryVersionModel;
